import { R } from '@angular/cdk/keycodes';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { AuthService } from 'app/auth/auth.service';
import { ChangedPriceProduct } from 'app/models/product/changed-price-product/changed-price-product';

@Component({
  selector: 'ultra-dialog-price-changed',
  templateUrl: './dialog-price-changed.component.html',
  styleUrls: ['./dialog-price-changed.component.scss'],

})
export class DialogPriceChangedComponent implements OnInit, AfterViewInit {
  stockProblem: boolean = false;
  priceProblem: boolean = false;
  quantityCols: number = 7;
  constructor(
    protected dialogRef: NbDialogRef<DialogPriceChangedComponent>,
    private toastrService: NbToastrService,
  ) { }

  ngAfterViewInit(): void {
    for (let index = 0; index < this.changedPrices.length; index++) {
      // Id da tag <td> com o nome do produto no html, productid + classificationId pois é um valor único
      let id = `${this.changedPrices[index].orderItem.productId}${this.changedPrices[index].orderItem.classificationId}`

      // Assim o nome do produto possui um colspan dinâmico para a quantidade de colunas que a tabela possui, pois usar 100% quebra a tabela
      document.getElementById(`${id}`).setAttribute("colspan", `${this.quantityCols}`);
    }
  }

  ngOnInit(): void {
    this.dialogRef.onBackdropClick.subscribe(() => { });
    this.changedPrices.map(element => {
      if (!element.active || element.stockQuantity <= 0) element.keep = false;
      // Verificar se a coluna irá existir na tabela e a quantidade de colunas que o nome do produto irá ocupar, 
      // se não tiver colspan exato a tabela pode quebrar, por isso a variável quantityCols para gerar dinamicamente o espaço ocupado
      if (element.newPrice != undefined) {
        this.priceProblem = true;
      }

      if (element.stockQuantity != undefined) {
        this.stockProblem = true;
      }

      if (this.priceProblem && this.stockProblem) {
        this.quantityCols = 9;
      }

    });
    this.controlAll();
  }

  changedPrices: ChangedPriceProduct[];
  canClose: boolean;
  allItems: boolean;

  keepItem(item) {
    if (item.active && (item.stockQuantity > 0 || !this.blockStock()))
      item.keep = true;
    this.controlAll();
  }

  blockStock(): boolean {
    return AuthService.extractTokenInfo('stockBlockOrder');
  }

  removeItem(item) {
    item.keep = false;
    this.controlAll();
  }

  removeAll() {
    this.changedPrices.map(element => element.keep = false);
    this.controlAll();
  }

  keepAll() {
    this.changedPrices.map(element => {
      this.keepItem(element);
    });
    this.controlAll();
  }

  controlAll() {
    const hasUndefined = this.changedPrices.some(n => n.keep === undefined);
    const hasTrue = this.changedPrices.some(n => n.keep === true);
    const hasFalse = this.changedPrices.some(n => n.keep === false);

    this.canClose = !hasUndefined;

    if (hasUndefined || hasTrue && hasFalse) {
      this.allItems = undefined;
    } else if (hasTrue && !hasFalse)
      this.allItems = true;
    else if (!hasTrue && hasFalse)
      this.allItems = false;
  }

  minus(index: number) {
    if(this.changedPrices[index].orderItem.quantity == 0)
      return;
    this.changedPrices[index].orderItem.quantity--;
  }

  plus(index: number) {
    this.changedPrices[index].orderItem.quantity++;
  }

  formatNumber(index: number) {
    this.changedPrices[index].orderItem.quantity.toString().replace(/\D/g, '');
    this.changedPrices[index].orderItem.quantity = Number.parseInt(this.changedPrices[index].orderItem.quantity.toString());
  }

  confirmSelection() {
    if (this.checkQuantity())
      return;
    this.dialogRef.close(this.changedPrices);
  }

  checkQuantity(): boolean {
    if (
      this.changedPrices.find((value: ChangedPriceProduct) => value.orderItem.quantity > value.stockQuantity && value.stockQuantity != null && value.keep) != undefined) {
      this.toastrService.danger("Diminua a quantidade dos itens destacados para uma quantidade suficiente ou remova-os", "Atenção, há produtos com estoque insuficiente", { duration: 6000 });
      return true;
    }
    else
      return false;
  }

  getStock(item: ChangedPriceProduct) {
    return item.stockQuantity ?? 0;
  }
}
